export enum ResourceType {
  ARTICLE = 'article',
  MEDIA = 'media',
  MOMENT = 'moment'
}
